export const METHOD = {
    POST: 'POST',
    GET: 'GET',
    PUT: 'PUT',
    PATCH: 'PATCH',
    DELETE: 'DELETE',
}

export const martId = '67271cd164b80a9e86a5c5ab'

export const DEFAULT_CATEGORY_ID = "673239e10be37b1fcec4303d"

export const BACKUP_EMERGENCY_CONTACT = 7050009899

export const SUPPORT_IMAGE_URL = "https://d1b9gfdt6jrhan.cloudfront.net/product/images/contact.jpg"

export const RETURN_TYPE = {
    REFUND: 'REFUND',
    REPLACEMENT: 'REPLACEMENT',
}